// Connect to the analytics channel
import consumer from "./consumer"

// How often the client re-arms the server-side presence marker. Must stay
// comfortably under AdminAnalyticsChannel::SUBSCRIBER_PRESENCE_TTL (90s) so
// the marker never expires while this tab is still connected.
const HEARTBEAT_INTERVAL_MS = 30000

consumer.subscriptions.create("AdminAnalyticsChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to AdminAnalyticsChannel")

    this.heartbeat = setInterval(() => this.perform("heartbeat"), HEARTBEAT_INTERVAL_MS)
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
    console.log("Disconnected from AdminAnalyticsChannel")

    clearInterval(this.heartbeat)
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    console.log("Received data on AdminAnalyticsChannel:", data)
    
    // Dispatch a custom event that our Stimulus controller can listen for
    const event = new CustomEvent('analytics:update', { detail: data })
    window.dispatchEvent(event)
  }
});
